var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.56908 9.03715C3.76435 9.23241 4.08093 9.23241 4.27619 9.03714L7.45817 5.85516C7.65343 5.6599 7.65343 5.34332 7.45817 5.14806C7.26291 4.95279 6.94632 4.95279 6.75106 5.14806L3.92264 7.97649L1.09421 5.14806C0.898946 4.9528 0.582363 4.9528 0.387101 5.14806C0.191839 5.34332 0.191839 5.65991 0.387102 5.85517L3.56908 9.03715ZM3.42263 0.352509L3.42264 8.68359L4.42264 8.68359L4.42263 0.352508L3.42263 0.352509Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDown);
export default __webpack_public_path__ + "static/media/ico-down.87e1164b54f9c5564125af5da1b90a48.svg";
export { ForwardRef as ReactComponent };